import { environment } from 'src/environments/environment';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { HttpClientModule, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { HttpLink } from 'apollo-angular/http';
import { ApolloClientOptions, ApolloLink } from '@apollo/client/core';
import { InMemoryCache } from '@apollo/client/cache';
import { Apollo, APOLLO_OPTIONS } from 'apollo-angular';
import { setContext } from '@apollo/client/link/context';
import { onError, ErrorResponse } from '@apollo/client/link/error';
import { AngularFireAuth } from '@angular/fire/auth';
import {
    BrowserTransferStateModule
} from '@angular/platform-browser';
import { Router } from '@angular/router';
import { take } from 'rxjs/operators';


@NgModule({
    imports: [
        CommonModule,
        BrowserTransferStateModule,
        HttpClientModule
    ]
})
export class GraphQLModule {


    constructor(
        apollo: Apollo,
        httpLink: HttpLink,
        private afAuth: AngularFireAuth,
        private router: Router
    ) {
        const endpoint = httpLink.create({ uri: environment.endpoint });
        const auth = setContext(() => {
            // get the authentication token from local storage if it exists
            return afAuth.idToken.pipe(take(1)).toPromise()
                .then(token => {
                    let mode;
                    return {
                        headers: new HttpHeaders()
                            .set('Partner', `${token}`)
                    };
                })
                .catch(err => {
                    console.log('firebase get token error!');
                });
        });
        const logoutLink = onError(({ networkError }: any) => {
            if (networkError &&
                'status' in networkError &&
                networkError.status === 403) {
                router.navigate(['/login']);
            }

            // if (graphQLErrors && graphQLErrors.status && graphQLErrors.status === 403) {
            //     this.router.navigate(['/login']);
            // }
        });

        const afterLink = new ApolloLink((operation, forward) => {
            return forward(operation).map((response: any) => {
                // this.layout.topProgressBar.next(true);
                // const roles = response.extensions.roles;
                // user.user.roles = roles.map(role => role.menuId);
                return response;
            });
        });

        const cache = new InMemoryCache({
            addTypename: true,
            dataIdFromObject: (o: any) => o.id
        });
        const link = ApolloLink.from([auth, logoutLink, afterLink, endpoint]);
        apollo.create({
            link,
            cache,
            connectToDevTools: true
        });
    }
}
